import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LiftTemperatureCriteria } from '../models/lift-temperature.criteria';
import { LiftTemperatureService } from './lift-temperature.service';

@Injectable({ providedIn: 'root' })
export class LiftTemperatureResolver implements Resolve<any> {
  constructor(
    private liftTemperatureService: LiftTemperatureService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    let temperatureCriteria = new LiftTemperatureCriteria();
    temperatureCriteria.liftId = route.params.id;

    return this.liftTemperatureService.getTemperatures(temperatureCriteria.paramsExport());
  }
}
